import Vue from 'vue'
import { LoadingPlugin } from "vuetify-loading-overlay"
Vue.use(LoadingPlugin, {
    spinnerProps: {
        size: 70,
        width: 7,
        color: "purple",
        indeterminate: true,
    },
    overlayProps: {
        zIndex: 99999999999999999,
    },
});